document.addEventListener('DOMContentLoaded', function() {
    const accordionItems = document.querySelectorAll('.production_options-item');
    const headerTitle = document.querySelector('.production_options-item-title');
    const headerVariantId = document.querySelector('.accordion-item-header-title');
    const priceElement = document.querySelector('.product-dropdown__price-value');
    const comparedPriceElement = document.querySelector('.product-dropdown__price-currency');
    const quantityButtonsContainer = document.querySelector('.product-dropdown__quantity');
    const addToCartButton = document.querySelector('.product-dropdown__button-link.btn-primary');
    const title = document.querySelector('.product-dropdown__title');
    const productImage = document.querySelector('.product-dropdown__img img');
    let specificProduct = '';

    function addSizeButtons(variants, specificVariant = false) {
        quantityButtonsContainer.innerHTML = '';

        variants.forEach((variant, index) => {
            let name = specificVariant ? variant.option1 : variant.title;
            let variantName = specificVariant ? variant.option2 : variant.title;
            const sizeButton = document.createElement('button');
            sizeButton.textContent = variantName;
            const comparedPrice = variant.option1 == "20 Meals" ? '$71.98' : '$95.98';
            sizeButton.classList.add('product-quantity');
            sizeButton.setAttribute('data-value', variant.option1);
            sizeButton.setAttribute('data-variant-id', variant.id);
            sizeButton.setAttribute('data-price', (variant.price / 100).toFixed(2));
            sizeButton.setAttribute('data-compare-at-price', variant.compare_at_price ? (variant.compare_at_price / 100).toFixed(2) : comparedPrice);

            if (index === 0) {
                name = specificVariant ? variant.option1 : variant.name.split('-')[0];
                sizeButton.classList.add('product-active');
                title.textContent = variantName;
            }

            sizeButton.addEventListener('click', function(e) {
                e.preventDefault();
                document.querySelectorAll('.product-quantity').forEach(btn => btn.classList.remove('product-active'));
                sizeButton.classList.add('product-active');
                updateProductDetails(variant, null, true); // Passa null como fallbackImage
            });

            quantityButtonsContainer.appendChild(sizeButton);
        });
    }

    function updateProductDetails(variant, fallbackImage, nameFromOption = false) {
        const name = nameFromOption ? variant.option1 : variant.name.split('-')[0];
        const comparedPrice = variant.option1 == "20 Meals" ? '$71.98' : '$95.98';
        if (headerTitle) headerTitle.textContent = name;
        if (title) title.textContent = name;
        if (priceElement) priceElement.textContent = '$' + (variant.price / 100).toFixed(2);
        if (comparedPriceElement) comparedPriceElement.textContent = variant.compare_at_price ? '$' + (variant.compare_at_price / 100).toFixed(2) : comparedPrice;

        if (headerVariantId) headerVariantId.setAttribute('data-variant-id', variant.id);
        if (variant.featured_image) {
            productImage.src = variant.featured_image.src;
            productImage.alt = variant.name;
        } else if (fallbackImage) {
            productImage.src = fallbackImage;
            productImage.alt = "";
        }
    }

    function changeImages() {
        const image = document.querySelector('.product-dropdown__image');
        document.querySelectorAll('.product-dropdown__thumbnails-item')
            .forEach((thumbnail, index) => {
                thumbnail.addEventListener('click', (e) => {
                    const thumbImage = thumbnail.querySelector('img');
                    e.preventDefault();
                    document.querySelectorAll('.product-dropdown__thumbnails-item').forEach(item => {
                        item.classList.remove('active');
                    });
                    thumbnail.classList.add('active');
                    image.src = thumbImage.src;
                });
            });
    }

    function updateAccordionDescription(title, item) {
        const variantData = JSON.parse(item.getAttribute('data-variant'));
        const option = variantData.filter(variant => variant.id == item.getAttribute('data-variant-specific'));
        title.textContent = option[0].option1;
    }

    async function addToCart() {
        const headerVariantId = document.querySelector('.accordion-item-header-title');
        const activeVariantId = headerVariantId.getAttribute('data-variant-id');
        const qtd = 1;

        const formData = new FormData();
        formData.append('id', activeVariantId);
        formData.append('quantity', qtd);

        const config = {
            method: 'POST',
            headers: {
                'Accept': 'application/javascript',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
        };

        fetch('/cart/add', config)
            .then(response => response.json())
            .then(response => {
                if (response.status) {
                    console.error('Error (Status): ', response.status);
                    return;
                }
                window.location.href = '/cart';
            }).catch(e => {
                console.error('Error (Cart API): ', e);
            });
    }

    function addThumbnailsImage(images) {
        const thumbnailsWrapper = document.querySelector('.product-dropdown__thumbnails .swiper-wrapper');
        const uniqueImageUrls = new Set();

        images.forEach((image, index) => {
            let imgRename = image.split('?')[0].toLowerCase();
            imgRename = imgRename.replaceAll('-20', '');
            imgRename = imgRename.replaceAll('-30', '');
            imgRename = imgRename.replaceAll('_30', '');
            imgRename = imgRename.replaceAll('-20_1', '');
            imgRename = imgRename.replaceAll('_1', '');
            imgRename = imgRename.replaceAll('._SX569', '');
            imgRename = imgRename.replaceAll('_c1746a9f-2f3e-4520-b2f6-6501739bf2e1', '');
            imgRename = imgRename.replaceAll('-30_1', '');

            if (!uniqueImageUrls.has(imgRename)) {
                uniqueImageUrls.add(imgRename);

                const swiperSlide = document.createElement('div');
                if (index === 0) {
                    swiperSlide.classList.add('swiper-slide', 'product-dropdown__thumbnails-item', 'active');
                } else {
                    swiperSlide.classList.add('swiper-slide', 'product-dropdown__thumbnails-item');
                }

                const thumbnail = document.createElement('img');
                thumbnail.src = image;
                thumbnail.alt = image.alt || 'image thumbnail';
                thumbnail.classList.add('product-dropdown__thumbnail-item-img');

                swiperSlide.appendChild(thumbnail);
                thumbnailsWrapper.appendChild(swiperSlide);
            }
        });
    }

    function descriptionAccordion(description) {
        const accordionContainer = document.getElementById('accordion-content');

        if (description === '' || description === null || description === undefined) {
            accordionContainer.classList.add('hidden');
            return;
        }
        accordionContainer.classList.remove('hidden');

        accordionContainer.innerHTML = '';

        const parser = new DOMParser();
        const doc = parser.parseFromString(description, 'text/html');
        const accordions = [
            { title: "Ingredients", content: doc.querySelector('.panel:nth-of-type(1) p')?.outerHTML || '' },
            { title: "Nutrition Facts", content: doc.querySelector('.panel:nth-of-type(2)')?.innerHTML || '' },
            { title: "How to Use", content: doc.querySelector('.panel:nth-of-type(3) p')?.outerHTML || '' }
        ];

        accordions.forEach(item => {
            const accordionItem = document.createElement('div');
            accordionItem.classList.add('accordion-item');

            const accordionHeader = document.createElement('div');
            accordionHeader.classList.add('accordion-item-header');
            accordionHeader.innerHTML = `
                <span class="accordion-item-header-title">${item.title}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down accordion-item-header-icon">
                    <path d="m6 9 6 6 6-6" />
                </svg>
            `;

            const accordionDescriptionWrapper = document.createElement('div');
            accordionDescriptionWrapper.classList.add('accordion-item-description-wrapper');

            const accordionDescription = document.createElement('div');
            accordionDescription.classList.add('accordion-item-description');
            accordionDescription.innerHTML = `${item.content}`;

            accordionDescriptionWrapper.appendChild(accordionDescription);
            accordionItem.appendChild(accordionHeader);
            accordionItem.appendChild(accordionDescriptionWrapper);
            accordionContainer.appendChild(accordionItem);
        });
    }

    if (addToCartButton) {
        addToCartButton.addEventListener('click', (e) => {
            e.preventDefault();
            //addToCart();
        });
    }

    accordionItems.forEach(item => {
        item.addEventListener('click', function(e) {
            e.preventDefault();
            const variantData = JSON.parse(item.getAttribute('data-variant'));
            const specific = item.getAttribute('data-variant-specific');
            const images = JSON.parse(item.getAttribute('data-images'));
            const thumbnailsWrapper = document.querySelector('.product-dropdown__thumbnails .swiper-wrapper');
            const description = JSON.parse(item.getAttribute('data-description'));
            const openAccordion = document.querySelector('.accordion-item.open');

            descriptionAccordion(description);
            setTimeout(() => {
                openAccordion.classList.toggle("open");
            }, 150)

            if (thumbnailsWrapper) {
                while (thumbnailsWrapper.firstChild) {
                    thumbnailsWrapper.removeChild(thumbnailsWrapper.firstChild);
                }
            }

            // Verifica se há uma variante específica
            if (specific) {
                const specificVariant = variantData.find(variant => variant.id == specific);
                if (specificVariant) {
                    addSizeButtons([specificVariant], true);
                    updateProductDetails(specificVariant, images[0], true);
                    addThumbnailsImage(images);
                    changeImages();
                }
            } else {
                addSizeButtons(variantData);
                updateProductDetails(variantData[0], images[0]);
                addThumbnailsImage(images);
                changeImages();
            }

            document.querySelectorAll(".product-dropdown__accordion-description .accordion-item").forEach((item) => {
                item.querySelector(".accordion-item-header").addEventListener("click", () => {
                    item.classList.toggle("open");
                });
            });

            new Swiper(".product-dropdown__thumbnails-slider", {
                slidesPerView: 6.2,
                spaceBetween: 6,
                loop: false,
                freeMode: true,
                centeredSlides: false,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    600: {
                        slidesPerView: 7.3,
                        spaceBetween: 10,
                    },
                    750: {
                        slidesPerView: 7.5,
                        spaceBetween: 10,
                    },
                    900: {
                        slidesPerView: 7.6,
                        spaceBetween: 10,
                    },
                    1024: {
                        slidesPerView: 6.6,
                        spaceBetween: 24,
                    }
                }
            });
        });

        if (item.getAttribute('data-variant-specific')) {
            specificProduct = item.querySelector('.production_options-item-title');
            updateAccordionDescription(specificProduct, item);
        }
    });

    if (accordionItems.length > 0) {
        const firstItem = accordionItems[0];
        const variantData = JSON.parse(firstItem.getAttribute('data-variant'));
        const images = JSON.parse(firstItem.getAttribute('data-images'));
        const description = JSON.parse(firstItem.getAttribute('data-description'));
        descriptionAccordion(description);
        addThumbnailsImage(images);
        changeImages();
        addSizeButtons(variantData);
        updateProductDetails(variantData[0], images[0]);

        new Swiper(".product-dropdown__thumbnails-slider", {
            slidesPerView: 4.2,
            spaceBetween: 6,
            loop: false,
            centeredSlides: false,
            freeMode: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                600: {
                    slidesPerView: 4.3,
                    spaceBetween: 10,
                },
                750: {
                    slidesPerView: 4.5,
                    spaceBetween: 10,
                },
                900: {
                    slidesPerView: 4.6,
                    spaceBetween: 10,
                },
                1024: {
                    slidesPerView: 4.7,
                    spaceBetween: 10,
                }
            }
        });
    }

    document.querySelectorAll(".accordion-item").forEach((item) => {
        item.querySelector(".accordion-item-header").addEventListener("click", () => {
            item.classList.toggle("open");
        });
    });
});
